document.addEventListener("DOMContentLoaded", function () {
  var modal = document.getElementById("imageModal"),
    modalImg = document.getElementById("modalImage"),
    popupLink = document.getElementById("popup-link"),
    span = document.getElementsByClassName("close")[0];

  if (popupLink && modal && modalImg) {
    popupLink.onclick = function () {
      modal.style.display = "flex";
      modalImg.src =
        "https://cdn.shopify.com/s/files/1/0071/9755/6794/files/download.jpg?v=1729211883";
    };
    if (span) {
      span.onclick = function () {
        modal.style.display = "none";
      };
    }
    window.addEventListener("click", function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var searchInput = document.getElementById("search-input");
  var searchButton = document.getElementById("search-button");
  var clearButton = document.getElementById("clear-button");
  var searchResults = document.getElementById("search-results");
  var postsContainer = document.querySelector(".c-blog__posts");
  var filterBtns = document.querySelectorAll(".c-blog__filter-btn");
  var filtersWrap = document.querySelector(".c-blog__filters");
  var loadMoreWrap = document.getElementById("load-more-wrap");
  var noResultsEl = document.getElementById("filter-no-results");

  var allArticlesEl = document.getElementById("all-articles-data");
  var allArticles = [];
  if (allArticlesEl) {
    try {
      allArticles = JSON.parse(allArticlesEl.textContent);
    } catch (e) {
      allArticles = [];
    }
  }

  function buildSearchCard(article) {
    var imageMarkup = "";
    if (article.image) {
      imageMarkup =
        '<div class="card__inner ratio" style="--ratio-percent: 66%;">' +
        '<div class="article-card__image-wrapper card__media">' +
        '<a href="' + article.url + '" class="article-card__image media media--hover-effect">' +
        '<img src="' + article.image + '" alt="' + (article.image_alt || "").replace(/"/g, "&quot;") + '" loading="lazy" width="800">' +
        "</a>" +
        "</div>" +
        "</div>";
    }

    var tagMarkup = "";
    if (article.tag_label) {
      tagMarkup =
        '<p class="article-card__tag caption-with-letter-spacing">' +
        article.tag_label +
        "</p>";
    }

    var dateMarkup = "";
    if (article.date) {
      dateMarkup =
        '<div class="article-card__info caption-with-letter-spacing">' +
        "<span>" + article.date + "</span>" +
        "</div>";
    }

    var excerptMarkup = "";
    if (article.excerpt) {
      excerptMarkup =
        '<p class="article-card__excerpt rte-width">' +
        article.excerpt +
        "</p>";
    }

    return (
      '<div class="c-blog__post blog-articles__article article" data-tag-slug="' + (article.tag_slug || "") + '">' +
      '<article class="card-wrapper article-card-wrapper underline-links-hover">' +
      '<div class="card article-card card--standard' + (article.image ? " card--media" : " card--text") + '">' +
      imageMarkup +
      '<div class="card__content">' +
      '<div class="card__information">' +
      tagMarkup +
      '<h3 class="card__heading">' +
      '<a href="' + article.url + '" class="full-unstyled-link">' + article.title + "</a>" +
      "</h3>" +
      dateMarkup +
      excerptMarkup +
      "</div>" +
      "</div>" +
      "</div>" +
      "</article>" +
      "</div>"
    );
  }

  function performSearch() {
    var query = searchInput.value.trim().toLowerCase();
    if (query.length < 3) {
      searchResults.innerHTML = "";
      searchResults.style.display = "none";
      clearButton.style.display = "none";
      if (postsContainer) postsContainer.style.display = "";
      if (filtersWrap) filtersWrap.style.display = "";
      if (loadMoreWrap) loadMoreWrap.style.display = "";
      if (noResultsEl) noResultsEl.style.display = "none";
      return;
    }

    var matches = allArticles.filter(function (a) {
      var title = (a.title || "").toLowerCase();
      var excerpt = (a.excerpt || "").toLowerCase();
      var tag = (a.tag_label || "").toLowerCase();
      return (
        title.indexOf(query) !== -1 ||
        excerpt.indexOf(query) !== -1 ||
        tag.indexOf(query) !== -1
      );
    });

    if (postsContainer) postsContainer.style.display = "none";
    if (filtersWrap) filtersWrap.style.display = "none";
    if (loadMoreWrap) loadMoreWrap.style.display = "none";

    var resultsContainer = document.createElement("div");
    resultsContainer.classList.add("c-blog__posts");

    if (matches.length > 0) {
      matches.forEach(function (a) {
        resultsContainer.innerHTML += buildSearchCard(a);
      });
      if (noResultsEl) noResultsEl.style.display = "none";
    } else {
      resultsContainer.innerHTML = "<p>No articles found.</p>";
    }

    searchResults.innerHTML = "";
    searchResults.appendChild(resultsContainer);
    searchResults.style.display = "block";
    clearButton.style.display = "inline-block";
  }

  searchButton.addEventListener("click", performSearch);
  searchInput.addEventListener("keydown", function (event) {
    if (event.key === "Enter") performSearch();
  });

  clearButton.addEventListener("click", function () {
    searchResults.innerHTML = "";
    searchResults.style.display = "none";
    clearButton.style.display = "none";
    searchInput.value = "";
    if (postsContainer) postsContainer.style.display = "";
    if (filtersWrap) filtersWrap.style.display = "";
    if (loadMoreWrap) loadMoreWrap.style.display = "";
    if (noResultsEl) noResultsEl.style.display = "none";
  });
});
